var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewsuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_62_1",
    "data-name": "Component 62 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 232,
    height: 168.024,
    viewBox: "0 0 232 168.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00be2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00be2c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(-6 -200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17251",
    "data-name": "Rectangle 17251",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "matrix(0.997, 0.079, -0.079, 0.997, 21.294, 233.688)",
    fill: "#d858fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17252",
    "data-name": "Rectangle 17252",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "matrix(0.985, 0.175, -0.175, 0.985, 174.564, 220.078)",
    fill: "#6dd400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17253",
    "data-name": "Rectangle 17253",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(94.487 321.132) rotate(-64.766)",
    fill: "#fbb700"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17254",
    "data-name": "Rectangle 17254",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(222.385 328.163) rotate(-30.048)",
    fill: "#ff4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17255",
    "data-name": "Rectangle 17255",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(20.128 349.754) rotate(-55.466)",
    fill: "#ff4848"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17256",
    "data-name": "Rectangle 17256",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(233.879 285.673) rotate(171.397)",
    fill: "#d858fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17257",
    "data-name": "Rectangle 17257",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(89.282 206.957) rotate(-30.048)",
    fill: "#32baec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17258",
    "data-name": "Rectangle 17258",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "translate(6 305.112) rotate(-30.048)",
    fill: "#6dd400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17259",
    "data-name": "Rectangle 17259",
    width: 13.895,
    height: 7.165,
    rx: 3.583,
    transform: "matrix(0.727, 0.687, -0.687, 0.727, 157.408, 244.615)",
    fill: "#ff4848"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10455",
    "data-name": "Group 10455",
    transform: "translate(-7.022 -192.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8984",
    "data-name": "Path 8984",
    d: "M204.926,323.566a19.334,19.334,0,0,1-9.667,16.743l-43.132,24.9a19.335,19.335,0,0,1-19.333,0l-43.132-24.9A19.333,19.333,0,0,1,80,323.566v-49.8a19.333,19.333,0,0,1,9.667-16.743l43.132-24.9a19.335,19.335,0,0,1,19.333,0l43.132,24.9a19.334,19.334,0,0,1,9.667,16.743Z",
    transform: "translate(-18.974 -7.57)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8985",
    "data-name": "Path 8985",
    d: "M136.347,248.117a19.335,19.335,0,0,1,19.333,0l32.828,18.953a19.332,19.332,0,0,1,9.667,16.743V321.72a19.332,19.332,0,0,1-9.667,16.743L155.68,357.416a19.335,19.335,0,0,1-19.333,0l-32.828-18.953a19.333,19.333,0,0,1-9.667-16.743V283.814a19.333,19.333,0,0,1,9.667-16.743Z",
    transform: "translate(-22.526 -11.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8986",
    "data-name": "Path 8986",
    d: "M163.284,319.006a3.925,3.925,0,0,0,1.544-3.775l-.993-5.888,4.28-4.216a3.875,3.875,0,0,0-2.159-6.561l-5.926-.895-2.646-5.326a3.958,3.958,0,0,0-6.941,0l-2.642,5.322-5.938.895a3.875,3.875,0,0,0-2.136,6.572l4.27,4.205-1,5.9a3.881,3.881,0,0,0,5.631,4.061l5.285-2.774,5.421,2.838A4.041,4.041,0,0,0,163.284,319.006Zm19.505,17.149-10.926-14.791a1.932,1.932,0,0,0-1.431-.784,1.879,1.879,0,0,0-1.521.588c-.233.242-1.2.5-3.3-.1a1.934,1.934,0,0,0-2.446,1.646c-.222,2-.782,2.895-1.185,3.057-.528.207-1.517-.162-2.706-1.038a1.932,1.932,0,0,0-2.937,2.276l7.641,18.735a1.931,1.931,0,0,0,3.16.65l7.164-7.164h6.93a1.933,1.933,0,0,0,1.559-3.076Zm-31.814-11.677a1.938,1.938,0,0,0-2.356.03c-1.491,1.182-2.495,1.4-2.933,1.2-.385-.158-.91-1.031-1.136-2.963a1.953,1.953,0,0,0-.838-1.373,1.931,1.931,0,0,0-1.585-.265c-1.914.518-2.922.351-3.209.06a1.87,1.87,0,0,0-1.521-.588,1.934,1.934,0,0,0-1.431.784l-10.925,14.791a1.933,1.933,0,0,0,1.559,3.076h6.93l7.164,7.164a1.931,1.931,0,0,0,3.16-.649l7.759-19A1.926,1.926,0,0,0,150.974,324.479Z",
    transform: "translate(-30.428 -23.15)",
    fill: "#e6f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8987",
    "data-name": "Path 8987",
    d: "M161.9,327.25a5.659,5.659,0,0,0,3.653-3.54,5.576,5.576,0,0,0,5-.74c1.01-.711,2.037-2.107,2.066-4.836,2.208-.271,3.731-1.16,4.514-2.57a5.692,5.692,0,0,0,.063-5.14,5.694,5.694,0,0,0,3.083-4.027c.185-1.25-.078-2.98-1.948-4.88a5.751,5.751,0,0,0,1.331-5.039,5.661,5.661,0,0,0-3.54-3.653,5.571,5.571,0,0,0-.741-5c-.71-1.011-2.106-2.037-4.835-2.066-.271-2.208-1.16-3.731-2.57-4.514a5.7,5.7,0,0,0-5.14-.064,5.7,5.7,0,0,0-4.027-3.082,5.771,5.771,0,0,0-4.88,1.947,5.751,5.751,0,0,0-5.039-1.331,5.661,5.661,0,0,0-3.653,3.54,5.576,5.576,0,0,0-5,.741c-1.011.711-2.037,2.107-2.066,4.835-2.208.272-3.731,1.16-4.514,2.571a5.693,5.693,0,0,0-.064,5.139,5.7,5.7,0,0,0-3.082,4.027c-.2,1.213.068,2.943,1.948,4.88a5.75,5.75,0,0,0-1.332,5.039c.31,1.158,1.179,2.606,3.577,3.644a5.721,5.721,0,0,0,.7,5.014c.711,1.01,2.107,2.036,4.835,2.066.272,2.208,1.16,3.731,2.571,4.514a5.691,5.691,0,0,0,5.139.063,5.7,5.7,0,0,0,4.027,3.083,5.772,5.772,0,0,0,4.88-1.948A5.751,5.751,0,0,0,161.9,327.25Zm-.9-12.483-6.032-3.545-6.346,2.9a1.977,1.977,0,0,1-2.03-.257,2.11,2.11,0,0,1-.68-1.939l1.536-6.814-4.737-5.134a2.052,2.052,0,0,1-.381-2.019,1.975,1.975,0,0,1,1.629-1.237l6.946-.661,3.451-6.086a1.943,1.943,0,0,1,3.454.195l2.8,6.413,6.811,1.376a2.028,2.028,0,0,1,.9,3.36l-5.21,4.6.782,6.953a1.943,1.943,0,0,1-2.893,1.9Z",
    transform: "translate(-31.913 -20.014)",
    fill: "#00bdff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsuccess);
export default __webpack_public_path__ + "static/media/reviewsuccess.ed2bc95f.svg";
export { ForwardRef as ReactComponent };